@theme {
  --inset-shadow-thin: inset 0 0 0 0.0625rem;
  --inset-shadow-thick: inset 0 0 0 0.125rem;
  --inset-shadow-thicker: inset 0 0 0 0.25rem;
  --shadow-color-5: rgb(0 0 0 / 0.05);
  --shadow-color-10: rgb(0 0 0 / 0.1);
  --shadow-color-25: rgb(0 0 0 / 0.25);
  --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
}
